<header>
    <div class="menu-header-left">
        <img src="../../../../assets/img/workspace-logo.png" class="workspace-logo" alt="workspace-logo">
        <mat-card-title>Code learning</mat-card-title>
    </div>
    <div class="img-edit-workspace icon-btn" (click)="changePath()"></div>
</header>